import axios from 'axios'

import type { ReportData } from 'common'
import { getToken } from '@/api/coreclient'
import { coreClient } from '@/api/coreclient'

export default {
  async create(body: Omit<ReportData, 'token'>) {
    const token = await getToken()

    return axios.post(
      import.meta.env.VITE_REPORT_SERVER_ENDPOINT,
      { ...body, token },
      {
        responseType: 'blob'
      }
    )
  },

  async asyncCreate(body: unknown) {
    const client = await coreClient()
    return client.propertyReport.generatePdfTask(body).then((res) => console.log(res))
  }
}
